import { Modal } from 'antd';

const ConfirmDeleteModal = ({
  isOpen,
  onConfirm,
  onCancel,
  title = 'Confirm Deletion',
  message,
}) => {
  return (
    <Modal
      title={title}
      open={isOpen}
      onOk={onConfirm}
      onCancel={onCancel}
      okText="Delete"
      okButtonProps={{ danger: true }}
    >
      <p>{message}</p>
    </Modal>
  );
};

export default ConfirmDeleteModal;
